/* eslint-disable react/destructuring-assignment */

import { FontAwesomeIcon, Props } from '@fortawesome/react-fontawesome';
import * as React from 'react';

import styles from './icon.module.scss';

interface IconProps extends Props {
  noMargins?: boolean;
  warning?: boolean;
  transparent?: boolean;
}

export default class Icon extends React.Component<IconProps> {
  private getFAProps() {
    const props = { ...this.props };
    delete props.noMargins;
    delete props.warning;
    delete props.transparent;

    return props;
  }

  public render() {
    const className =
      `${styles.icon} ${this.props.noMargins ? styles.noMargins : ''} ` +
      `${this.props.warning ? styles.warning : ''}` +
      `${this.props.transparent ? styles.transparent : ''}`;

    return (
      <span className={className}>
        <FontAwesomeIcon {...this.getFAProps()} />
      </span>
    );
  }
}
